
export const ADMIN_MODULE_INIT = `admin.init`;

export const RA_MODULE_INIT = `ra.init`;

export const IC_MODULE_INIT = `ic.init`;

export const IH_MODULE_INIT = `ih.init`;

export const BAP_MODULE_INIT = `2bap.init`;
export const BAP_MODULE_REPORTS_PAGE_INIT = `2bap.reports-page-init`;
export const BAP_MODULE_PARENT_SHARE_PAGE_INIT = `2bap.parent-share-page-init`;
export const BAP_MODULE_APPLY_JUDGEMENT = `2bap.apply-judgement`;
export const BAP_APPLY_ASSESSMENT_FILTER = `2bap.apply-assessment-filter`;

/**
 * @enum
 */
export const INFORMATION_POPUP_CONTEXT_CODES = {
  ADMIN_MODULE_INIT,
  RA_MODULE_INIT,
  IC_MODULE_INIT,
  IH_MODULE_INIT,
  BAP_MODULE_INIT,
  BAP_MODULE_REPORTS_PAGE_INIT,
  BAP_MODULE_PARENT_SHARE_PAGE_INIT,
  BAP_MODULE_APPLY_JUDGEMENT,
  BAP_APPLY_ASSESSMENT_FILTER
};
